import { useGetList, useRedirect } from 'react-admin';
import { Stack, Typography, Grid, useTheme, useMediaQuery, Box } from '@mui/material';
import CardInformation from '../components/CardInformation';

interface CustomerCardListProps {
  userId: string;
  expanded: boolean;
}

const CustomerCardList = ({ userId, expanded }: CustomerCardListProps) => {
  const theme = useTheme();
  const isSmall = useMediaQuery(theme.breakpoints.down('sm'));
  const redirect = useRedirect();

  const { data: cards = [] } = useGetList('cards', {
    pagination: { page: 1, perPage: 100 },
    sort: { field: 'createdAt', order: 'DESC' },
    filter: { userId },
  });

  if (!cards.length) {
    return <Typography>No cards found</Typography>;
  }

  return (
    <Grid container spacing={3}>
      {cards.map((card) => (
        <Grid 
          item 
          xs={12} 
          sm={6} 
          key={card.id}
          sx={{
            '& > div': {
              // Target the CardInformation root div
              width: '100% !important',
              '& > div': {
                // Target the inner card component
                width: '100% !important',
                maxWidth: '400px',
                margin: '0 auto',
                height: 'auto !important',
                cursor: 'pointer',
                '& button': {
                  // Hide the expand button
                  display: 'none'
                }
              }
            }
          }}
        >
          <Box onClick={() => redirect('show', 'cards', card.id)}>
            <CardInformation selectedCardId={card.id} forceExpanded={expanded} />
          </Box>
        </Grid>
      ))}
    </Grid>
  );
};

export default CustomerCardList; 